import PropTypes from 'prop-types';
import { PageId, WorkflowIdEnum } from './api/useWorkflowDataQuery';

export const WORKFLOW_WIDTH = 890;
export const WORKFLOW_PADDING = 32;

export interface WorkflowComponentProps {
  isFirstStep: boolean;
  pageId: PageId;
  stepId: string;
  workflowId: WorkflowIdEnum;
  onPrevious(): void;
  onNext(): void;
}

export const workflowPropsPropTypes = PropTypes.shape({
  isFirstStep: PropTypes.bool,
  pageId: PropTypes.string,
  stepId: PropTypes.string,
  workflowId: PropTypes.number,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
});

export const PAGE_MAP: Record<PageId, string> = {
  [PageId.Start]: 'start',
  [PageId.InviteClient]: 'WorkflowInviteClient',
  [PageId.PersonalInfo]: 'ProfilePersonalInfo',
  [PageId.RiskTolerance]: 'ProfileRiskTolerance',
  [PageId.Goals]: 'ProfileGoals',
  [PageId.Accounts]: 'ProfileAccounts',
  [PageId.ManageLinks]: 'ProfileAccounts',
  [PageId.OtherAssets]: 'ProfileOtherAssets',
  [PageId.StockOptions]: 'ProfileStockOptions',
  [PageId.TaxFiling]: 'ProfileTaxFiling',
  [PageId.Expenses]: 'ProfileExpenses',
  [PageId.Income]: 'ProfileIncome',
  [PageId.Insurance]: 'ProfileInsurance',
  [PageId.DocumentVault]: 'DocumentVault',
  [PageId.EstatePlanningPersonalInfo]: 'ProfilePersonalInfo',
  [PageId.EstatePlanningWorkflowReview]: 'EstatePlanningWorkflowReview',
};
